export default __webpack_public_path__ + "static/media/apple-juice-menu@2x.ecf51360.png";